import { updateUserDetails } from "../../../redux/slice/formUpdateSlice";
import { consoleLog } from "../../../utils/log-utils";
import {
  listRequest,
  loginRequest,
  createUpdateAction,
  updateRequest,
} from "../../service/UserService";

/**
 * Login Action
 *
 * @param {*} data  JSON DATA TO SEND TO SERVER
 * @returns API RESULT
 */
export const loginAction = (requestData) => async (dispatch) => {
  const response = await dispatch(loginRequest(requestData));
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status === 201) ||
    200
  ) {
    consoleLog(response.data, "login response");
    
    await localStorage.setItem("authToken", response.data.result.token);
    await localStorage.setItem("userId", response.data.result.id);
    await localStorage.setItem("userRoleId", response.data.result.role_id);
    await localStorage.setItem("userName", response.data.result.name);
    await localStorage.setItem("userEmail", response.data.result.email);
    await localStorage.setItem("userPhone", response.data.result.phone);
    await localStorage.setItem("userImage", response.data.result.image_path);
    await localStorage.setItem("userPassword", response.data.result.password);
    await localStorage.setItem(
      "superuserId",
      response.data.result.super_user_id
    );
    await localStorage.setItem("orgId", response.data.result.orgId);
   await dispatch(updateUserDetails({
    userDetails:{
      userId:response.data.result.id,
      userRoleId:response.data.result.role_id,
      userName:response.data.result.name,
      userEmail:response.data.result.email,
      userImage:response.data.result.image_path
    }
   }))
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
export const listAction = () => async (dispatch) => {
  const response = await dispatch(listRequest());
  consoleLog("", response);
  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    consoleLog("", response);
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
export const updateUserActon = (data) => async (dispatch) => {
  const response = await dispatch(updateRequest(data));

  if (
    (response &&
      Object.keys(response).length &&
      response?.data?.status == 201) ||
    200
  ) {
    return Promise.resolve(response.data);
  } else {
    return Promise.resolve(null);
  }
};
